import { fbt } from 'fbtee'
import { Users } from 'lucide-react'
import { ThumbStack } from '../../components/profile/ThumbStack'
import { Button } from '../../components/ui/button'
import type { Group } from '../../types'

/** Shown when none of the viewer's groups is on the event yet: their groups' covers and a way to pick one. */
export function LinkGroupPromptCard({
  groups,
  isFestival,
  onPick,
}: {
  groups: Group[]
  isFestival: boolean
  onPick: () => void
}) {
  return (
    <div className="flex flex-col gap-3 rounded-lg border bg-card p-4">
      <div className="flex items-center gap-3">
        <ThumbStack srcs={groups.map(g => g.imageUrl)} icon={Users} size="md" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold">
            {fbt('Who are you going with?', 'Title of the event page card asking the user to link one of their groups')}
          </p>
          <p className="text-xs text-muted-foreground">
            {isFestival ? (
              <fbt desc="Body of the event page card asking the user to link one of their groups">
                Link a group so everyone in it sees who's in and which sets overlap.
              </fbt>
            ) : (
              <fbt desc="Body of the party page card asking the user to link one of their groups">
                Link a group so everyone in it sees who's in.
              </fbt>
            )}
          </p>
        </div>
      </div>
      <Button variant="secondary" size="sm" className="self-start" onClick={onPick}>
        {fbt('Pick a group', 'Button on the event page card that opens the link-a-group picker')}
      </Button>
    </div>
  )
}
